import { css } from "@emotion/css";

export const footerTextStyles = css`
  font-size: 0.1rem;
`;

export const copyRightStyles = css`
  font-size: 12px !important;
`;
